<template>
	<div class="wutuNew">
		<ul>
			<li
				v-for="(item, index) in dataList"
				:key="item.ID"
				@mouseenter="hoverRoll(item)"
				class="wow fadeInLeft"
				:data-wow-delay="index / 8 + 's'"
			>
				<a
				:href="item.FileUrl"
				class="flexDiv">
				<div class="textBox flexDiv">
					<span>{{ setTimeformat(item.ShowTime, "yyyy-mm-dd") }}</span>
					<p class="title txt-cut1">{{ item.Title }}</p>
				</div>
				<div class="text_img">
				</div>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'noImgList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
.wutuNew {
  width: 1200px;
  ul {
		width: 100%;
		height: auto;
		display: inline-block;
		vertical-align: top;
		box-sizing: border-box;
		li {
		width: 100%;
		height: 30px;
		margin-bottom: 30px;
    padding-right: 15px;
		font-size: 0;
		border-bottom: dashed 1px #e4e4e4;
		box-sizing: border-box;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		&:last-child {
			margin-bottom: 0px;
		}
    &:hover{
      a{
        .text_img{
          background: url(../assets/img/xiazai_hover.png) center no-repeat;
        }
      }
    }
			a {
			width: 100%;
			height: 30px;
      position: relative;
			.text_img {
				display: block;
        width: 18px;
        height: 17px;
				margin: 0;
        background: url(../assets/img/xiazai.png) center no-repeat;
			}
			.textBox {
			font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 1;
      letter-spacing: 1px;
      color: #333333;
      margin-left: 10px;
			span{
				width: 115px;
				display: block;
			}
			p{
				font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: 1px;
        color: #333333;
        margin-left: 30px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
				&::before {
				content: "";
				width: 4px;
        height: 4px;
        background-color: #333333;
				border-radius: 50%;
				display: block;
				position: absolute;
				top: 8px;
				left: 0px;
				}
			}
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/noImgList.vue